/**
 * Maps a roof condition score (1–5) to its display color and label.
 * Used by PropertyViewModelMapperService and property-overview styles.
 */
export interface IRoofScoreDefinition {
  color: string;
  label: string;
}

/** Shared status colors reused across roof scores and DS progress bars */
export const COLOR_RED = "#DE3509";
export const COLOR_ORANGE = "#EE7105";
export const COLOR_YELLOW = "#FEAC00";
export const COLOR_LIME = "#A2E412";
export const COLOR_GREEN = "#34B37E";

export const ROOF_SCORE_MAP: Record<number, IRoofScoreDefinition> = {
  1: { color: COLOR_RED, label: "Bad" },
  2: { color: COLOR_ORANGE, label: "Poor" },
  3: { color: COLOR_YELLOW, label: "Fair" },
  4: { color: COLOR_LIME, label: "Good" },
  5: { color: COLOR_GREEN, label: "Great" },
};

